import { render } from "./ResourceTableRow.vue?vue&type=template&id=36903078&scoped=true"
import script from "./ResourceTableRow.vue?vue&type=script&lang=js"
export * from "./ResourceTableRow.vue?vue&type=script&lang=js"

import "./ResourceTableRow.vue?vue&type=style&index=0&id=36903078&scoped=true&lang=css"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36903078"],['__file',"ResourceTableRow.vue"]])

export default __exports__